cdm_blocks.fn.ready(()=>{
    var slider = tns({
        container: '.slider-partners',
        items: 3,
        loop: true,
        mouseDrag: true,
        gutter: 30,
        controls: false,
        nav: false,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        center: true,
        edgePadding:15,
        responsive: {
            1050:{
               items: 8, 
               edgePadding:0,
            },
            678: {
                items:5
            }
        },
    });
});